import { getOrders } from '@front/common/endpoints'
import { NextOrder } from '@front/common/types'
import { Ref } from '@vue/composition-api'
import { useStore, useVuex } from '@vueblocks/vue-use-vuex'

import useApiState from '@member-area/core/hooks/useApiState'

import { INSERT_ORDERS } from './constants'

const useOrder = () => {
  const store = useStore()
  const { useGetters } = useVuex()
  const [onFetchOrdersSuccess, fetchOrdersState, fetchOrders]: any[] =
    useApiState(getOrders)

  onFetchOrdersSuccess(({ data }) => {
    if (!data) {
      return
    }

    store.commit(INSERT_ORDERS, data)
  })

  return {
    ...(useGetters({
      orders: 'order/get',
    }) as { orders: Ref<NextOrder[]> }),
    fetchOrdersState,
    fetchOrders,
  }
}

export default useOrder
